import {
  Component,
  Inject,
  Injector,
  forwardRef,
  ViewEncapsulation,
  ElementRef,
  Renderer,
  Optional,
  NgModule,
  EventEmitter
} from '@angular/core';

import { CommonModule } from '@angular/common';

import { InputConverter } from '../../../decorators';
import { OListItemComponent } from '../list-item/o-list-item.component';
import { OListItemCardRenderer } from './o-list-item-card-renderer.class';
import { OSharedModule } from '../../../shared';

export const DEFAULT_INPUTS_O_LIST_ITEM_CARD_IMAGE = [
  ...OListItemCardRenderer.DEFAULT_INPUTS_O_CARD_RENDERER,
  'avatar'
];

export const DEFAULT_OUTPUTS_O_LIST_ITEM_CARD_IMAGE = [
  ...OListItemCardRenderer.DEFAULT_OUTPUTS_O_CARD_RENDERER
];



export class OListItemCardImageComponent extends OListItemCardRenderer {

  protected _content: string;
  protected _avatar: string;
  protected _icon: string;
  @InputConverter()
  protected _collapsible: boolean = false;
  @InputConverter()
  protected _collapsed: boolean = true;

  onIconClick: EventEmitter<Object> = new EventEmitter<Object>();

  constructor(
    elRef: ElementRef,
    _renderer: Renderer,
    _injector: Injector,
      _listItem: OListItemComponent
  ) {
    super(elRef, _renderer, _injector, _listItem);
  }

  ngAfterViewInit() {
    this.modifyMdListItemElement();
  }

  onActionIconClick(event: any) {
    this.onIconClick.emit(event);
  }

  get content(): string {
    return this._content;
  }

  set content(val : string) {
    this._content = val;
  }

  get avatar(): string {
    return this._avatar;
  }

  set avatar(val : string) {
    this._avatar = val;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(val : string) {
    this._icon = val;
  }

  get collapsible(): boolean {
    return this._collapsible;
  }

  set collapsible(val : boolean) {
    this._collapsible = val;
  }

  get collapsed(): boolean {
    return this._collapsed;
  }

  set collapsed(val : boolean) {
    this._collapsed = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list-item-card-image',
  template: `
    <md-card fxLayout="column" fxLayoutAlign="center center" class="o-item-card" [class.small]="compareListHeight('small')"
      [class.medium]="compareListHeight('medium')" [class.large]="compareListHeight('large')">

      <md-card-header *ngIf="avatar !== undefined">
        <img mdCardAvatar src="{{ avatar }}">
        <md-card-title *ngIf="title !== undefined"> {{ title }}</md-card-title>
        <md-card-subtitle *ngIf="subtitle !== undefined"> {{ subtitle }}</md-card-subtitle>
      </md-card-header>

      <img *ngIf="image !== undefined" mdCardImage src="{{ image }}" [class.exists-action-button]="icon !== undefined">

      <button *ngIf="icon !== undefined && compareListHeight('small')" md-mini-fab (click)="onActionIconClick($event)" class="action-button">
          <md-icon>{{ icon }}</md-icon>
        </button>

      <button *ngIf="icon !== undefined && (compareListHeight('medium') || compareListHeight('large'))" md-fab (click)="onActionIconClick($event)"
        class="action-button">
          <md-icon>{{ icon }}</md-icon>
      </button>

      <md-card-title *ngIf="avatar === undefined && title !== undefined"> {{ title }}</md-card-title>
      <md-card-subtitle *ngIf="avatar === undefined && subtitle !== undefined"> {{ subtitle }}</md-card-subtitle>

      <md-card-content *ngIf="!collapsible">
        <p>
          {{ content }}
        </p>
      </md-card-content>

      <md-card-actions>
        <button md-button *ngIf="action1Text !== undefined" (click)="onAction1ButtonClick($event)">{{ action1Text }}</button>
        <button md-button *ngIf="action2Text !== undefined" (click)="onAction2ButtonClick($event)">{{ action2Text }}</button>

        <div class="collapse-button-container">
          <button md-icon-button *ngIf="collapsible" (click)="collapsed = !collapsed" class="collapse-button">
            <md-icon *ngIf="collapsed">keyboard_arrow_down</md-icon>
            <md-icon *ngIf="!collapsed">keyboard_arrow_up</md-icon>
          </button>
        </div>
      </md-card-actions>

      <md-card-content *ngIf="collapsible && !collapsed">
        <p>
          {{ content }}
        </p>
      </md-card-content>

    </md-card>
  `,
  styles: [`
    o-list-item md-list-item.o-card-item .mat-list-item-content{height:auto}.o-list-item-card-image md-card md-card-title,.o-list-item-card-image md-card md-card-subtitle,.o-list-item-card-image md-card md-card-actions,.o-list-item-card-image md-card md-card-header{width:100%}.o-list-item-card-image md-card.large{width:100%}.o-list-item-card-image md-card.medium{width:80%}.o-list-item-card-image md-card.small{width:60%}.o-list-item-card-image md-card.small img.exists-action-button{margin-bottom:-20px}.o-list-item-card-image md-card:not(.small):not(.medium):not(.large){width:100%}.o-list-item-card-image md-card .action-button{margin-left:auto}.o-list-item-card-image md-card img.exists-action-button{margin-bottom:-28px}.o-list-item-card-image md-card .collapse-button-container{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;position:relative}.o-list-item-card-image md-card .collapse-button-container .collapse-button{margin-left:calc(100% - 40px)}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_LIST_ITEM_CARD_IMAGE,
    'content',
    'avatar',
    'icon',
    'collapsible',
    'collapsed'
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIST_ITEM_CARD_IMAGE,
    'onIconClick : icon-action'
  ],
  encapsulation: ViewEncapsulation.None,
  host: {
    'layout-padding': '',
    '[class.o-custom-list-item]': 'true',
    '[class.o-list-item-card-image]': 'true'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer, },
{type: Injector, },
{type: OListItemComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OListItemComponent), ] }, ]},
];
}


export class OListItemCardImageModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OListItemCardImageComponent],
  imports: [
    OSharedModule,
    CommonModule
  ],
  exports: [OListItemCardImageComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
